const NONE = 0
const SINGLE = 1
const SPLIT = 2
const TRIPLE_SPLIT = 3
const QUADRUPLE_SPLIT = 4

export default { NONE, SINGLE, SPLIT, TRIPLE_SPLIT, QUADRUPLE_SPLIT }
